import React from 'react';
import style from './StrydCardSmall.module.css';
import timeIcon from '../../assets/timeIcon.svg';
import formatDisplayName from '../../utils/formatDisplayName';
import VerifiedBadge from '../VerifiedBadge/VerifiedBadge';

const StrydCardSmall = (props) => {
	const creatorName = props.creator ? formatDisplayName(props.creator) : 'Routine';

	return (
		<div className={style.StrydCardSmall}>
			<div className={style.RoutineNameWrapper}>
				<span className={style.RoutineName}>{props.name}</span>
				<span className={style.RoutineDetail}>
					Created by {creatorName}
					<VerifiedBadge userPlan={props.creatorUserPlan} totalXP={props.creatorTotalXP} size='small' />
				</span>
			</div>

			<div className={style.RoutineAtrributesWrapper}>
				<div className={style.AttributesWrapper}>
					<img src={timeIcon} alt='' className={style.TimeIcon} />
					<span className={style.TimeText}>{props.time} mins</span>
				</div>
			</div>
		</div>
	);
};

export default StrydCardSmall;